import { Factory } from 'miragejs';

export default Factory.extend({
  code: '401000',
  name: 'Fournisseurs',
  createdAt: () => new Date('2023-11-20T10:14:35.120Z'),
  updatedAt: () => new Date('2023-11-20T12:17:01.988Z'),
});
